import angular from 'angular';
import geolocation from 'angularjs-geolocation';

// Libraries
import uiModal from 'angular-ui-bootstrap/src/modal';
import datepickerPopup from 'angular-ui-bootstrap/src/datepickerPopup';
import datepicker from 'angular-ui-bootstrap/src/datepicker';
import 'angular-bootstrap-checkbox';

// Dependencies
import servicesModuleName from '../../../../../lib/service';
import geoServiceModule from '../../../../../lib/service/GeoService';

// Translations
import translate from '../../../../../lib/translation';

// Component
import component from './locationSelector.component';

const moduleName = 'staff.dashboardScreen.locationSelector';
let module = angular.module(moduleName, [
  datepickerPopup,
  datepicker,
  servicesModuleName,
  geoServiceModule.name,
  uiModal,
  'geolocation',
  translate,
  'ui.checkbox',
  'angularMoment',
]);

module.component('locationSelector', component);

export default module;

